import { createAction, props } from '@ngrx/store';

export const addError = createAction(
  '[Error] Add Error',
  props<{ id: number; msg: string; code: number; pageId: string }>()
);

export const removeError = createAction(
  '[Error] Remove Error',
  props<{ id: number }>()
);

export const removeErrorsByPageId = createAction(
  '[Error] Remove Errors By Page Id',
  props<{ pageId: string }>()
);
